module.exports = __webpack_public_path__ + "static/media/akLogo.532f9735.png";